module.exports = __webpack_public_path__ + "static/media/IMG_0408_Reduced.810ee3e3.jpg";